import axios from "axios";

const baseUrl = "https://atharva-patil-portfolio.herokuapp.com"; //process.env.API ||
const api = `${baseUrl}/api`;

const axiosInstance = axios.create({
  baseURL: api,
  headers: {
    "Content-Type": "application/json",
    Authorization: "Bearer",
    "Access-Control-Allow-Origin": "http://localhost:3000",
    "Access-Control-Allow-Credentials": "true",
  },
});

export default axiosInstance;
